<template>
  <div aria-hidden="true">
    <button tabindex="-1" @click.stop="clickBot" class="senas-video" :aria-label="videoShow&&active?'Cerrar':'Abrir' +' video en lenguaje de señas'">
      <div class="acces-icon back-red hvr-grow">
        <v-icon class="always-white">fa fa-sign-language</v-icon>
      </div>
      <div class="acces-bot-name back-red animated fadeIn">
        <p class="always-white">{{videoShow&&active?'Ocultar':'Ver'}} video en LSC</p>
      </div>
    </button>
    <v-flex xs12 v-if="videoShow && active" class="animated fadeIn">
      <video-app :videoSize="600" :vidTittle="vidTittle" :videoEmbed="videoEmbed" :youtubeEmbed="youtubeEmbed"></video-app>
    </v-flex>
  </div>
</template>

<script>
export default {
  props: {
    vidTittle: {
      type: String,
      required: true
    },
    videoEmbed: {
      type: String,
      required: false
    },
    youtubeEmbed: {
      type: String,
      required: false
    },
    videoglosario:{
      type:Boolean,
      default: false,
      required: false
    },
    videoId:{
      type: Number,
      required: false,
      default: 0
    },
    active:{
      type:Boolean,
      default: true,
      required: false
    },
  },
  data() {
    return {
      videoShow: false
    };
  },
  methods: {
    toggleVideo(){
      //Si es un video de glosario, se maneja con el prop active. Entonces videoShow siempre será true
      if(this.videoglosario){
        this.videoShow=true;
      }else{
        this.videoShow = !this.videoShow;      
      }
    },
    clickBot() {
      this.toggleVideo();
      this.$emit("hideVideo", this.videoShow, this.videoId);
    },
    is_glosario(){ //Si es un video de glosario, se maneja con el prop active. Entonces videoShow siempre será true
      if(this.videoglosario){
        this.videoShow=true;
      }
    }
  },
  mounted(){
    this.is_glosario();
  }
};
</script>



// WEBPACK FOOTER //
// ui-simple-lsc.vue?27b312e3